import sanityClient from '@sanity/client';

export default sanityClient({
	projectId: 'pfi5rmcj',
	dataset: 'production',
	useCdn: true,
});
